import {KTSVG} from '../../../../../../_metronic/helpers'
import {useCompanyListView} from '../core/CompanyListViewProvider'

const CompanyEditModalHeader = () => {
  const {setItemIdForUpdate, itemIdForUpdate} = useCompanyListView()

  console.log({itemIdForUpdate})

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>{itemIdForUpdate ? 'Edit Company' : 'Add Company'}</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() => setItemIdForUpdate(undefined)}
        style={{cursor: 'pointer'}}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {CompanyEditModalHeader}
